<template>
  <ul class="row list-style mt-3">
    <li
      class="col-6 col-sm-4 list-style-li"
      v-for="news in newsList"
      :key="news.newsId"
      @click.prevent="moveToDetail(news.newsId)"
    >
      <div class="list-style-label" :class="getStyleClass(news.newsType.code)">
        {{ changeCRSNaming(news.newsType.text) }}
      </div>
      <!-- 병헌 : 인셀덤 라벨 -->
      <a href="">
        <img :src="news.thumbnailImageUrl" alt="" class="list-style-img" />
        <h2 class="list-style-tit mt-15 mb-1">
          {{ mobileDeviceCheck ? news.title.substr(0,24) + '...' : news.title }}
        </h2>
      </a>
      <div class="list-style-date mt-1">{{ $moment(news.createDatetime).format('YYYY. MM. DD') }}</div>
    </li>
  </ul>

</template>

<script>
export default {
  name: 'NewsListSection',
  props: {
    newsList: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      mobileDeviceCheck: false,
    };
  },
  created() {
    const filter = 'win16|win32|win64|mac|macintel';
    if (navigator.platform) {
      if (filter.indexOf(navigator.platform.toLowerCase()) < 0) {
        this.mobileDeviceCheck = true;
      } else {
        this.mobileDeviceCheck = false;
      }
    }
  },
  methods: {
    moveToDetail(newsId) {
      this.$emit('move-to-detail', newsId);
    },
    getStyleClass(type) {
      return type.toLowerCase();
    },
    changeCRSNaming(name) {
      if (name === 'CSR(사회공헌)') {
        return '사회공헌';
      }
      return name;
    },
  },
};
</script>
